import { analyticsApi } from './analytics';
import { createFetchApi } from './client';
import { flagApi } from './flags/index';
import { fleetApi } from './fleet';
import { oauthApi } from './oauth/index';
import { publicApi } from './public';
import {
  AuthenticationStrategyInvalidEmailError,
  InvitationAlreadyAcceptedError,
  LoginError,
  OAuthInteractionInvalidError,
  ResetPasswordError,
  UnexpectedAuthenticationStrategyError,
  userApi,
} from './user/index';

export const apiClient = {
  fleet: fleetApi(createFetchApi()),
  user: userApi(createFetchApi()),
  oauth: oauthApi(createFetchApi()),
  flag: flagApi(createFetchApi()),
  analytics: analyticsApi(createFetchApi()),
  public: publicApi(createFetchApi()),
};

export type { AssetInfos } from './public';
export type { AuthenticationStrategy, UserApi } from './user/types';
export {
  AuthenticationStrategyInvalidEmailError,
  InvitationAlreadyAcceptedError,
  LoginError,
  OAuthInteractionInvalidError,
  ResetPasswordError,
  UnexpectedAuthenticationStrategyError,
};
